import React from 'react';
import { createRoot } from 'react-dom/client';
import { Autocomplete } from "./components/Autocomplete";

import 'whatwg-fetch';

export function mount(props) {
    const container = document.getElementById(props.containerId)
    const root = createRoot(container);
    return root.render(<Autocomplete {...props} />);
}

export function asQueryParams(suggestion) {
    return `?prefix=${suggestion.properties.prefix || ''}&housenumber=${suggestion.properties.housenumber || ''}&street=${suggestion.properties.street}&suffix=${suggestion.properties.suffix || ''}&postcode=${suggestion.properties.postcode}&citycode=${suggestion.properties.citycode}&city=${suggestion.properties.city}`;
}

export {getCoords} from "./utils/map/geocodingUtils";
